import { reactive, toRefs, computed, provide, inject } from "@vue/composition-api";
import { actions as dialogActions } from "./dialog";
import { $t } from "@/i18n";
import router from "../../router";
export const state = reactive({
    validation_errors: {}
});

export const actions = {
    clear_validation_errors() {
        state.validation_errors = {};
    },
    clear_validation_error(key) {
        state.validation_errors[key] = "";
    },
    handleError(error) {
        const isObject = obj => {
            return obj === Object(obj);
        };
        if (error && error.data) {
            const error_type = error.data.error_type;
            const error_body = error.data;
            const error_list = error_body.errors;
            if (error_type === "session_expired") {
                router.push({ name: "login" });
                // window.location = "/login";
            }
            if (error_type === "form_validation") {
                if (error_list.length) {
                    if (isObject(error_list[0])) {
                        const validation_alert_error = error_list.find(e => !!e.show_alert);
                        // case where validation should raise alert dialog, is marked 'show_alert' on backend
                        if (validation_alert_error) {
                            let title;
                            let text;
                            if (validation_alert_error.title) title = validation_alert_error.title;
                            if (validation_alert_error.error_message) text = validation_alert_error.error_message;
                            if (validation_alert_error.text) text = validation_alert_error.text;
                            dialogActions.setErrorOptions({
                                title,
                                text
                            });
                            dialogActions.openError();
                        } else {
                            error_list.forEach(err => {
                                const err_key = "{0}_error".format(err.field);
                                state.validation_errors = Object.assign({}, state.validation_errors, {
                                    [err_key]: err.error_message
                                });
                            });
                        }
                    } else if (typeof error_list[0] === "string") {
                        error_list.forEach((err, index) => {
                            const err_key = index ? "generic_error_" + index : "generic_error";
                            state.validation_errors = Object.assign({}, state.validation_errors, {
                                [err_key]: err
                            });
                        });
                    }
                }
                return true;
            } else {
                const error_strings_list = [];
                let title, text;
                for (const error_index in error_list) {
                    const err = error_list[error_index];
                    if (typeof err === "string") {
                        error_strings_list.push(err);
                    }
                }
                if (error_strings_list.length === 1) {
                    title = $t("Error!");
                    text = error_strings_list[0];
                }
                if (error_strings_list.length >= 2) {
                    title = error_strings_list[0];
                    text = error_strings_list[1];
                }
                dialogActions.setErrorOptions({
                    title,
                    text
                });
                dialogActions.openError();
            }
        }
    }
};

export const getters = {
    validation_errors: computed(() => {
        return state.validation_errors;
    })
};

export const key = Symbol("ErrorModule");

export const provideError = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
